import React from "react";
import { _goToBack } from "router/helper";

import { View, ViewProps, StyleSheet } from "react-native";

import Button from "component/button/Button";
import Text from "component/typography/Text";
import ImageIcon from "component/typography/ImageIcon";

import { colors, sizes, strings } from "asset/constant";
import { mq } from "utils";
import { icon } from "asset/icon";

export default function Empty(props: ErrorT & ViewProps) {
  const { error, loading, reset } = props;

  const networkError = error?.code === "ERR_NETWORK";
  const notFound = error?.response?.status === 404;

  return (
    <View style={[styles.container]}>
      <ImageIcon
        size={mq(128)}
        color={networkError ? "#3c638255" : undefined}
        icon={
          notFound
            ? icon.not_found
            : networkError
            ? icon.connection_error
            : icon.server_error
        }
        style={{ marginBottom: sizes.space }}
      />

      <Text color={colors.text.normal} weight="bold" size={"xxl"}>
        {networkError
          ? strings.connection_error
          : notFound
          ? strings._404_error
          : strings.server_error}
        !
      </Text>

      <Button
        onPress={notFound ? _goToBack : reset ? reset : undefined}
        title={{
          value: notFound ? strings.return : strings.do_again,
          color: colors.info,
        }}
        icon={{ name: notFound ? "arrowright" : "reload1", color: colors.info }}
        loading={loading}
        width="auto"
        height={mq(35)}
        bgColor={colors.transparent}
        style={{ paddingHorizontal: mq(20), margin: mq(30) }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, alignItems: "center", justifyContent: "center" },
});
